import { Requester } from './Requester';
import { IOrgRecord } from '../types';

export const GetOrganizationById = async (orgId: string): Promise<IOrgRecord | null> => {
    try {
        const response = await Requester<IOrgRecord>({
            // port: '8080',
            path: `organizations/${orgId}`,
            method: 'GET'
        });

        return Object.hasOwn(response, '_id') ? (response as IOrgRecord) : null;
    } catch (e) {
        console.error('Get orgs request failed');
        return Promise.reject(e);
    }
};
